import FloatLabel from "./FloatLabel";
import ErrorLabel from "./ErrorLabel";
import { Input } from "@chakra-ui/react";
import { useController } from "react-hook-form";

export default function InputControl({ control, name, label, placeholder, type = "text", isDisabled = false, isRequired = false, rules, ...rest }) {
	const {
		field: { value = "", onBlur, onChange, ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label ? label : "Input" } is required`, ...rules },
	});
	return (
		<>
			<FloatLabel label={label} isRequired={isRequired}>
				<Input type={type} value={value} placeholder={placeholder} onChange={onChange} isDisabled={isDisabled} {...field} {...rest} />
				<ErrorLabel>{error?.message}</ErrorLabel>
			</FloatLabel>
		</>
	);
}
